import React from 'react'
import { NavLink } from 'react-router-dom';
import routes from '../../routers/helpers/routes';
import EmailModal from './EmailModal';

export default function HeaderHome() {
  return (
    <div>
      <header className="bg-dark py-4">
        <div className="container px-5">
          <div className="row gx-5 justify-content-center">
            <div className="col-lg-6">
              <div className="text-center my-5">
              
                <i id= "icon" className="fas fa-paper-plane nav-icon" />
                
                <h1 className="display-5 fw-bolder text-white mb-2">
                    Envía mensajes de texto masivos a tus clientes de manera profesional
                </h1>
                <p className="lead text-white-50 mb-4">
                  Ofrece descuentos, recuerda tus citas, envía felicitaciones, invitaciones y más... Dale a tu negocio el estatus que merece con sms-marketing, la mejor forma de llegar a tus clientes con un bajo presupuesto y alto impacto.
                </p>
                <div className="d-grid gap-3 d-sm-flex justify-content-sm-center">
                  <a
                    className="btn btn-primary btn-lg px-4 me-sm-3"
                    href="#emailModal" role="button" data-bs-toggle="modal"
                  >
                    Quiero Empezar
                  </a>
                  <NavLink className="btn btn-outline-light btn-lg px-4 mx-2" to={routes.login}>
                    Inicia Sesión
                  </NavLink>
                  
                  {/* Modal HTML */}

                    <div id="emailModal" className="modal fade" tabIndex="-1">
                      <div className="modal-dialog">
                        <div className='modal-content font-mulish'>
                          <EmailModal />
                        </div>
                      
                        
                      </div>
                    </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </div>
  );
}
